(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ssk-build-your-setup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssk-setup')) {
    customElements.define('ssk-setup', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.pending = false;
        this.added = false;
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style:'currency', currency:this.dataset.currency || 'USD' });
        this.rows = Array.from(this.querySelectorAll('[data-setup-row]'));
        this.kayak = this.querySelector('[data-setup-kayak]');
        this.addButton = this.querySelector('[data-setup-add]');
        this.fields = this.querySelector('[data-setup-fields]');
        this.clearButton = this.querySelector('[data-setup-clear]');
        this.status = this.querySelector('[data-setup-status]');
        this.addEventListener('change', () => this.update());
        this.clearButton.addEventListener('click', () => {
          this.rows.forEach(row => { row.querySelector('[data-setup-check]').checked = false; });
          this.status.textContent = '';
          this.update();
        });
        this.addButton.addEventListener('click', () => this.addSetup());
        this.update();
      }
      format(cents) { return this.money.format(cents / 100); }
      selection() {
        const kayak = this.kayak.selectedOptions[0];
        let complete = Boolean(kayak && kayak.value && !kayak.disabled);
        let subtotal = 0;
        const items = new Map();
        if (complete) items.set(kayak.value, { id:kayak.value, quantity:1 });
        for (const row of this.rows) {
          const checked = row.querySelector('[data-setup-check]').checked;
          const option = row.querySelector('[data-setup-variant]').selectedOptions[0];
          const price = row.querySelector('[data-setup-price]');
          price.textContent = option && option.value ? this.format(Number(option.dataset.price)) : this.dataset.from + ' ' + this.format(Number(price.dataset.fromPrice));
          if (!checked) continue;
          if (!option || !option.value || option.disabled) { complete = false; continue; }
          if (!items.has(option.value)) {
            subtotal += Number(option.dataset.price);
            items.set(option.value, { id:option.value, quantity:1 });
          }
        }
        return { complete, subtotal, total:Number(kayak?.dataset.price || 0) + subtotal, items:Array.from(items.values()) };
      }
      update() {
        const state = this.selection();
        this.querySelector('[data-setup-subtotal]').textContent = state.complete ? this.format(state.subtotal) : this.dataset.choose;
        this.querySelector('[data-setup-total]').textContent = state.complete ? this.format(state.total) : this.dataset.choose;
        this.addButton.disabled = this.pending || this.added || !state.complete;
        this.clearButton.disabled = this.pending || this.added || !this.rows.some(row => row.querySelector('[data-setup-check]').checked);
      }
      async addSetup() {
        if (this.pending || this.added) return;
        const state = this.selection();
        if (!state.complete) return;
        this.pending = true;
        this.fields.disabled = true;
        this.addButton.textContent = this.dataset.adding;
        this.status.textContent = '';
        this.update();
        try {
          await new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', this.dataset.cartAddUrl);
            request.timeout = 20000;
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Accept', 'application/json');
            request.onload = () => {
              try {
                const result = JSON.parse(request.responseText);
                if (request.status < 200 || request.status >= 300) {
                  reject(new Error(typeof result.description === 'string' ? result.description : this.dataset.error));
                } else resolve(result);
              } catch { reject(new Error(this.dataset.error)); }
            };
            request.onerror = request.ontimeout = () => reject(new Error(this.dataset.error));
            request.send(JSON.stringify({ items:state.items }));
          });
          this.added = true;
          this.addButton.hidden = true;
          this.querySelector('[data-setup-view]').hidden = false;
          this.status.textContent = this.dataset.added;
        } catch (error) {
          this.status.textContent = error.message || this.dataset.error;
          this.querySelector('[data-setup-view]').hidden = false;
        } finally {
          this.pending = false;
          this.fields.disabled = this.added;
          this.addButton.textContent = this.dataset.add;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssk-custom-build"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ssk-custom-build')) {
    customElements.define('ssk-custom-build', class extends HTMLElement {
      connectedCallback() {
        if (window.location.hash === '#ssk-custom-build') this.querySelector('details').open = true;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        document.addEventListener('click', event => {
          if (!event.target.closest('[data-ssk-custom-open]')) return;
          const details = this.querySelector('details');
          if (details) details.open = true;
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssk-fishing-team"] && !Shopify.designMode) return;
  try {
    
(() => {
 const hydrate=host => {
  if (!host || !host.dataset.sskPortal || host.dataset.sskHydrated) return;
  host.dataset.sskHydrated='true';
  let portal;
  try { portal = new URL(host.dataset.sskPortal); if(portal.protocol !== 'https:') return; } catch { return; }
  const safe = (value, kinds=['https:']) => { try { const u=new URL(value);return kinds.includes(u.protocol)&&!u.username&&!u.password?u.href:null; } catch {return null;} };
  const el = (tag, cls, text) => { const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e; };
  const anchor=(url,label)=>{const a=el('a','',label);a.href=url;return a;};
  const labels={pro:host.dataset.sskTierPro,team:host.dataset.sskTierTeam,ambassador:host.dataset.sskTierAmbassador};

  const updateBanner=async members=>{
    const collage=host.querySelector('.ssk-team__collage');if(!collage)return;
    const shuffled=list=>{const copy=list.slice();for(let i=copy.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[copy[i],copy[j]]=[copy[j],copy[i]];}return copy;};
    const queues=shuffled(members).map(m=>shuffled((m.gallery||[]).map(g=>safe(g.photo)).filter(Boolean)));
    const candidates=[],seen=new Set();
    const add=url=>{if(url&&!seen.has(url)){seen.add(url);candidates.push(url);}};
    for(let round=0;round<12;round++)for(const queue of queues)add(queue[round]);
    shuffled(members).forEach(m=>add(safe(m.photo)));
    collage.querySelectorAll('img').forEach(img=>add(safe(img.currentSrc||img.src)));
    if(!candidates.length)return;
    const loaded=[];
    for(const url of candidates){
      if(loaded.length===5)break;
      const image=new Image();image.alt='';image.decoding='async';
      const ok=await new Promise(resolve=>{const timer=setTimeout(()=>resolve(false),3500);image.onload=()=>{clearTimeout(timer);resolve(true);};image.onerror=()=>{clearTimeout(timer);resolve(false);};image.src=url;});
      if(ok)loaded.push(image);
      if(!host.isConnected)return;
    }
    if(!loaded.length||!host.isConnected)return;
    const tiles=loaded.map(image=>{const tile=el('div','ssk-team__collage-tile');tile.append(image);return tile;});
    collage.replaceChildren(...tiles);
  };

  const loadPublicTeam=()=>new Promise((resolve,reject)=>{
    const script=document.createElement('script');script.src=new URL('/team-feed.js',portal).href;script.async=true;script.referrerPolicy='no-referrer';
    const cleanup=()=>{clearTimeout(timer);window.removeEventListener('ssk:approved-team',receive);script.remove();};
    const receive=event=>{cleanup();resolve(event.detail);};
    const timer=setTimeout(()=>{cleanup();reject(Error('Unavailable'));},8000);
    window.addEventListener('ssk:approved-team',receive,{once:true});
    script.onerror=()=>{cleanup();reject(Error('Unavailable'));};document.head.append(script);
  });
  loadPublicTeam().then(value=>{if(!value||!Array.isArray(value.members))throw Error('Invalid feed');const members=value.members;
    if(members.some(m=>!m||typeof m.name!=='string'||!Object.hasOwn(labels,m.tier)||typeof m.id!=='string'||!Array.isArray(m.gallery||[])||!Array.isArray(m.favorites||[])))throw Error('Invalid profiles');
    updateBanner(members).catch(()=>{});
    const roster=host.querySelector('.ssk-team__body');if(!roster)return;
    const container=el('div','ssk-team__approved-roster');
    for(const tier of ['pro','team','ambassador']){const list=members.filter(m=>m.tier===tier);if(!list.length&&tier!=='ambassador')continue;const group=el('section','ssk-team__tier ssk-team__tier--'+tier);const heading=el('h3','ssk-team__tier-heading',labels[tier]);group.append(heading);if(tier==='ambassador')group.append(el('p','ssk-team__ambassador-intro',host.dataset.sskAmbassadorIntro));const grid=el('div','ssk-team__grid');group.append(grid);if(!list.length){const visit=anchor(portal.href,host.dataset.sskMemberArea+' →');visit.className='ssk-team__profile-link';group.append(visit);}
      for(const m of list){const card=el('article','ssk-team__member'),portrait=el('div','ssk-team__portrait');const image=safe(m.photo);if(image){const img=el('img');img.src=image;img.alt=m.name;img.loading='lazy';img.width=900;img.height=675;portrait.append(img);}card.append(portrait);const content=el('div','ssk-team__member-content');content.append(el('h4','',m.name));if(m.hometown)content.append(el('p','ssk-team__tagline',m.hometown));if(m.kayak)content.append(el('p','ssk-team__kayak',m.kayak));
        const details=el('details','ssk-team__bio'),summary=el('summary','',host.dataset.sskAbout.replace('SSK_MEMBER_NAME',m.name)),plus=el('span','','+');plus.setAttribute('aria-hidden','true');summary.append(plus);details.append(summary);const bio=el('div');bio.append(el('p','',m.bio||host.dataset.sskBioSoon));const full=anchor(new URL('/members/'+encodeURIComponent(m.id),portal).href,host.dataset.sskViewProfile+' →');full.className='ssk-team__profile-link';bio.append(full);details.append(bio);content.append(details);
        const links=el('div','ssk-team__links');for(const [key,label]of Object.entries({instagram:host.dataset.sskInstagram,facebook:host.dataset.sskFacebook,youtube:host.dataset.sskYoutube,tiktok:host.dataset.sskTiktok,website:host.dataset.sskWebsite})){const url=safe(m[key]);if(url)links.append(anchor(url,label));}if(links.childElementCount)content.append(links);card.append(content);grid.append(card);
      }container.append(group);
    }
    const old=roster.querySelectorAll(':scope > .ssk-team__tier, :scope > .ssk-team__approved-roster');const first=old[0];if(first)first.before(container);else roster.append(container);old.forEach(node=>node.remove());
  }).catch(()=>{delete host.dataset.sskHydrated;});
 };
 const mount=scope=>scope.querySelectorAll('[data-ssk-portal]').forEach(hydrate);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
 document.addEventListener('shopify:section:load',event=>mount(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
